import React from 'react';
import statusIcon from 'static/images/icons/pending.png';
import { printf } from 'utils/i18n';
import './style.scss';

interface IBDisabledEntryProps {
    desc?: React.ReactNode;
}

const IBDisabledEntry: React.FC<IBDisabledEntryProps> = ({ desc }) => {
    return (
        <div className="ib-disabled-entry-root">
            <img className="icon" src={statusIcon} alt="" />
            <h3 className="title">{__('Account Functions have moved!')}</h3>
            {desc ? (
                <p className="desc">{desc}</p>
            ) : (
                <p
                    className="desc"
                    dangerouslySetInnerHTML={{
                        __html: printf(
                            __(
                                `Please visit Interactive Brokers' client portal to request deposits/withdrawals. If you do not have login access, please click <a href="%s">here</a> to retrieve your IB login username and password.`
                            ),
                            '/profile/security/link'
                        )
                    }}
                />
            )}
        </div>
    );
};

export default IBDisabledEntry;
